import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CategoryMappingData } from '../../../masterscreen/model/life-saving.model';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../services/common.service';
import { ConstantsService } from '../../services/constants.service';

@Component({
	selector: 'ara-category',
	templateUrl: './category.component.html',
	styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit, OnChanges {
	lifeSavingMappingRequest: CategoryMappingData;
	specificationData: SpecificationData[];
	isLifeSavingChecked: boolean = false;
	lifeSavingCheckedValue: any[];
	@Output() categoryCheckedValueEmittedData = new EventEmitter();
	@Input() moduleId: number = 0;
	@Input() sourceId: number;
	@Input() disabled: boolean = false;
  @Input() isActive: boolean = false;
    @Input() ImportedCategoryData:any;
	@Input() checkImport:number = 0;
	@Input() riskManagementToolId: number = 0;
	specificationResponseData: SpecificationData;
	public isShowCategory: boolean = false;
	isShowSpecification: boolean = false;
	moduleName: string;

	constructor(private baseService: BaseService, private masterscreenService: MasterscreenService,
		private commonService: CommonService,
		private translate: TranslateService) {
		this.lifeSavingMappingRequest = new CategoryMappingData();
		this.specificationData = [];
		this.lifeSavingCheckedValue = [];
	}

	ngOnInit() {
		//this.getLifeSavingMappingDetailsByModuleId(this.moduleId);
		this.baseService.translatorListener.subscribe((data) => {
			this.translate.use(data);
		});
	}
	ngOnChanges() {
		if(this.moduleId)
		{
		this.getLifeSavingMappingDetailsByModuleId(this.moduleId,this.riskManagementToolId);
		
		}
	}

	getLifeSavingMappingDetailsByModuleId(moduleId,riskManagementToolId) {
		
		
		var keys = Object.keys(ConstantsService.PermissionMatrixModules);
		keys.forEach(key => {
			if (ConstantsService.PermissionMatrixModules[key] === moduleId) {
				this.moduleName = key;
				return;
			}
		});
		this.lifeSavingMappingRequest.ModuleId = moduleId;
		if(riskManagementToolId != null && riskManagementToolId != undefined && riskManagementToolId != 0){
		this.lifeSavingMappingRequest.RiskManagementToolId = riskManagementToolId;
		}
		this.lifeSavingMappingRequest.IsActive = this.sourceId > 0  && !this.isActive ? false : true;
		if(this.moduleName == "Observation" || this.moduleName == "Incident")
		{
			this.lifeSavingMappingRequest.IsActive = false;
		}
		const apiRequest = {
			Model: this.lifeSavingMappingRequest
		};
		this.masterscreenService.getcategoryMappingDetailsByModuleId(apiRequest, this.callbackMethodForgetLifeSavingMappingDetailsByModuleId.bind(this));
	}
	callbackMethodForgetLifeSavingMappingDetailsByModuleId(response) {
		
		this.specificationData = [];
		if (response.Success) {
			this.isShowCategory = true;
			this.isShowSpecification = false;
			this.specificationData = response.Result;
			
			if (this.sourceId > 0) {
				this.getSpecificationData();
			}
			if(this.checkImport == 1 && this.ImportedCategoryData != undefined && this.ImportedCategoryData != null)
			{
				this.lifeSavingCheckedValue = [];
		        this.resetCategoryData();
			    this.specificationResponseData = this.ImportedCategoryData;
			    if (this.specificationResponseData.ModuleId === this.moduleId && this.specificationResponseData.SourceId === this.sourceId) {
				this.isShowSpecification = true;
				this.isShowCategory = false;
				this.specificationResponseData.RuleId.forEach(checkedrule => {
					for (var i = 0; i < this.specificationData.length; i++) {
						for (var j = 0; j < this.specificationData[i].LstCategoryRuleGroupedByCategoryId.length; j++) {
							if (this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].RuleId === checkedrule) {
								this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].Checked = true;
								this.lifeSavingCheckedValue.push(checkedrule);
							}
						}
					}
				});
			}
			this.categoryCheckedValueEmittedData.emit(this.lifeSavingCheckedValue);
		  }
		}
	}

	submitCheckedLifeSavingValue(specificationData, event) {
		if (event.target.checked) {
			this.isLifeSavingChecked = true;
			this.lifeSavingCheckedValue.push(specificationData.RuleId);
		} else {
			const index = this.lifeSavingCheckedValue.indexOf(specificationData.RuleId);
			if (index > -1) {
				this.lifeSavingCheckedValue.splice(index, 1);
			}
		}
		this.categoryCheckedValueEmittedData.emit(this.lifeSavingCheckedValue);
	}
	getSpecificationData() {
		const apiRequest = {
			Model: {
				SourceId: this.sourceId,
				ModuleId: this.moduleId
			}
		};
		this.commonService.getCategoryData(apiRequest, this.callbackMethodForGetSpecificationData.bind(this));
	}

	callbackMethodForGetSpecificationData(response) {
		this.lifeSavingCheckedValue = [];
		this.resetCategoryData();
		if (response && response.Success) {
			this.specificationResponseData = response.Result;
			if (this.specificationResponseData.ModuleId === this.moduleId && this.specificationResponseData.SourceId === this.sourceId) {
				this.isShowSpecification = true;
				this.isShowCategory = false;
				this.specificationResponseData.RuleId.forEach(checkedrule => {
					for (var i = 0; i < this.specificationData.length; i++) {
						for (var j = 0; j < this.specificationData[i].LstCategoryRuleGroupedByCategoryId.length; j++) {
							if (this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].RuleId === checkedrule) {
								this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].Checked = true;
								this.lifeSavingCheckedValue.push(checkedrule);
							}
						}
					}
				});
			}
			this.categoryCheckedValueEmittedData.emit(this.lifeSavingCheckedValue);
		}
	}

	resetCategoryData(): void {
		for (var i = 0; i < this.specificationData.length; i++) {
			for (var j = 0; j < this.specificationData[i].LstCategoryRuleGroupedByCategoryId.length; j++) {
				this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].Checked = false;
			}
		}
	}
}

export class SpecificationData {
	ModuleId: number;
	SourceId: number;
	RuleId: any[] = [];
	LstCategoryRuleGroupedByCategoryId: any[] = [];
	Checked: boolean;
	CategoryName: string;
}
